export const validateCurrencyCode = ({
  availableCurrencyCodes,
  lockedCurrencyCode,
  displayedCurrencyCode,
  currencyCode
}) => {
  const isCurrencyAvailable = availableCurrencyCodes.includes(currencyCode);
  const isDifferentFromLocked = lockedCurrencyCode !== currencyCode;
  if (lockedCurrencyCode && isDifferentFromLocked) {
    return lockedCurrencyCode;
  }
  if (isCurrencyAvailable) {
    return currencyCode;
  }
  return displayedCurrencyCode;
};